import { PageHeader } from '@/components/common/PageHeader';
import { useEntity } from '@/hooks/useEntity';
import { ENTITY_TYPES } from '@/lib/constants/entity-types';
import { CommandCenterTop } from './components/CommandCenterTop';
import { IssueReportBuyPrompt } from './components/IssueReportBuyPrompt';
import { LegalCommandCenterSections } from './components/LegalCommandCenterSections';
import { DATA_ROOM_STRINGS } from './constants';

/**
 * The Legal Command Center (`/data-room`, MYN-331, FR-299, FR-300; design
 * §53). Every logged-in user, not only startup members: the top opens what
 * they already have, offers the renewal, or the Issue Report; below it the
 * Due Diligence page's legal-services sections, so the two pages never differ.
 *
 * The path stays `/data-room`, which emails, the DAXE handoff return and the
 * "Get an Issue Report" links already point at. What the top shows comes only
 * from the backend's entitlement answer (§12), resolved in `CommandCenterTop`.
 */
export function DataRoomPage() {
  const entity = useEntity();
  const startup = entity?.entityType === ENTITY_TYPES.STARTUP ? entity : null;

  return (
    <div className="bg-page-bg min-h-full">
      <PageHeader title={DATA_ROOM_STRINGS.PAGE.TITLE} />
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-6 px-4 py-10">
        {startup ? <CommandCenterTop startup={startup} /> : <IssueReportBuyPrompt />}
      </div>
      <LegalCommandCenterSections />
    </div>
  );
}
